import { z } from "zod";

import { useFeatureFlags } from "@smart/bridge-feature-flags-dom";
import { useStorage } from "@smart/itops-hooks-dom";
import { Alert } from "@smart/itops-sb-design-system-dom";

import { useIntakeSettingsNavigation } from "../../settings/navigate";

export type AutomaticRemindersOffBannerProps = {
  scheduleEnabled?: boolean | null;
};

export const AutomaticRemindersOffBanner = ({
  scheduleEnabled,
}: AutomaticRemindersOffBannerProps) => {
  const { "LINK-3736": automaticRemindersFlag } = useFeatureFlags();
  const { navigate } = useIntakeSettingsNavigation();
  const [dismissed, setDismissed] = useStorage({
    key: "dismissed-banner.manage-reminders-automation-off",
    storage: "local",
    schema: z.boolean(),
    defaultValue: false,
  });

  if (!automaticRemindersFlag || scheduleEnabled || dismissed) return null;

  return (
    <Alert
      variant="info"
      palette="default"
      heading="Automatic reminders are off"
      content="Turn them on to chase unsubmitted forms on a schedule, sent via the client portal."
      actions={[
        {
          text: "Set up automatic reminders",
          onClick: () => navigate("client-messages"),
        },
      ]}
      onClose={() => setDismissed(true)}
    />
  );
};
